import React, { useEffect, useState } from 'react';
import { Link2, ChevronRight, Star, Calendar, Clock, MessageSquare, Gift, ArrowUp, Sparkles, Zap, Lock, ArrowUpRight, ChevronLeft, Users } from 'lucide-react';
interface Angel {
  id: string;
  name: string;
  avatar: string;
  relationshipLevel: number;
  lastInteraction: string;
  compatibility: number;
  dailyBonusAvailable: boolean;
  intimacyScore: number;
  messageStreak: number;
  giftsSent: number;
  milestones: {
    title: string;
    description: string;
    completed: boolean;
    reward?: string;
  }[];
  insights: string[];
  status: 'favorite' | 'active' | 'inactive';
}
export const RelationshipTracking: React.FC = () => {
  const [selectedAngel, setSelectedAngel] = useState<Angel | null>(null);
  const [filter, setFilter] = useState<'all' | 'favorites' | 'active' | 'inactive'>('all');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [selectedMilestone, setSelectedMilestone] = useState<any>(null);
  const [showInsightModal, setShowInsightModal] = useState(false);
  const [selectedInsight, setSelectedInsight] = useState<string | null>(null);
  const [showDailyBonus, setShowDailyBonus] = useState(false);
  const [dailyBonusClaimed, setDailyBonusClaimed] = useState(false);
  // Sample angels data
  const angels: Angel[] = [{
    id: '1',
    name: 'Sophia',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    relationshipLevel: 6,
    lastInteraction: 'Today',
    compatibility: 87,
    dailyBonusAvailable: true,
    intimacyScore: 420,
    messageStreak: 8,
    giftsSent: 3,
    milestones: [{
      title: 'First Confession',
      description: 'Sophia shared a personal secret with you',
      completed: true,
      reward: 'Exclusive photo set'
    }, {
      title: 'Deep Connection',
      description: 'Reached intimacy level 5 with Sophia',
      completed: true,
      reward: '50 tokens'
    }, {
      title: 'Perfect Match',
      description: 'Achieve 90% compatibility with Sophia',
      completed: false
    }],
    insights: ['Sophia responds best to your messages in the evening', 'She appreciates your romantic compliments', 'Try sharing more about your day-to-day life'],
    status: 'favorite'
  }, {
    id: '2',
    name: 'Harper',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    relationshipLevel: 4,
    lastInteraction: 'Yesterday',
    compatibility: 72,
    dailyBonusAvailable: true,
    intimacyScore: 310,
    messageStreak: 5,
    giftsSent: 2,
    milestones: [{
      title: 'First Date',
      description: 'Completed your first video call with Harper',
      completed: true,
      reward: 'Special voice message'
    }, {
      title: 'Gift Appreciation',
      description: 'Send Harper 5 gifts',
      completed: false
    }],
    insights: ['Harper loves discussing your hobbies', 'She responds well to your humor', 'Try sending her more voice messages'],
    status: 'active'
  }, {
    id: '3',
    name: 'Lana',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    relationshipLevel: 8,
    lastInteraction: 'Today',
    compatibility: 92,
    dailyBonusAvailable: false,
    intimacyScore: 580,
    messageStreak: 15,
    giftsSent: 7,
    milestones: [{
      title: 'Soulmate Status',
      description: 'Reached relationship level 8 with Lana',
      completed: true,
      reward: 'Exclusive video call'
    }, {
      title: 'Perfect Harmony',
      description: 'Achieved 90%+ compatibility',
      completed: true,
      reward: 'Custom fantasy fulfillment'
    }],
    insights: ['Lana appreciates your consistency and attention', 'She loves when you remember details about her life', 'Try planning more virtual dates'],
    status: 'favorite'
  }, {
    id: '4',
    name: 'Bonny Blue',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    relationshipLevel: 3,
    lastInteraction: '3 days ago',
    compatibility: 65,
    dailyBonusAvailable: false,
    intimacyScore: 180,
    messageStreak: 0,
    giftsSent: 1,
    milestones: [{
      title: 'Breaking the Ice',
      description: 'Complete 10 conversations with Bonny',
      completed: true,
      reward: 'Special photo'
    }],
    insights: ['Bonny misses your conversations', 'She responds well to assertive communication', 'Try reconnecting with a thoughtful message'],
    status: 'inactive'
  }, {
    id: '5',
    name: 'Kim Holland',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    relationshipLevel: 2,
    lastInteraction: '5 days ago',
    compatibility: 58,
    dailyBonusAvailable: false,
    intimacyScore: 120,
    messageStreak: 0,
    giftsSent: 0,
    milestones: [{
      title: 'First Connection',
      description: 'Started a relationship with Kim',
      completed: true
    }],
    insights: ['Kim is waiting to get to know you better', 'She enjoys discussing travel and adventure', 'Try asking about her interests'],
    status: 'inactive'
  }, {
    id: '11',
    name: 'GoldenShowerTina',
    avatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png',
    relationshipLevel: 5,
    lastInteraction: 'Today',
    compatibility: 78,
    dailyBonusAvailable: true,
    intimacyScore: 350,
    messageStreak: 6,
    giftsSent: 4,
    milestones: [{
      title: 'Kinky Connection',
      description: 'Shared your fantasies with Tina',
      completed: true,
      reward: 'Special roleplay session'
    }, {
      title: 'Golden Supporter',
      description: 'Send 5 premium gifts to Tina',
      completed: false
    }],
    insights: ['Tina appreciates your openness about desires', 'She loves your adventurous attitude', 'Try exploring new fantasy scenarios together'],
    status: 'active'
  }];
  const filteredAngels = angels.filter(angel => {
    if (filter === 'all') return true;
    if (filter === 'favorites') return angel.status === 'favorite';
    if (filter === 'active') return angel.status === 'active';
    if (filter === 'inactive') return angel.status === 'inactive';
    return true;
  });
  const handleAngelClick = (angel: Angel) => {
    setSelectedAngel(angel);
  };
  const handleBackClick = () => {
    setSelectedAngel(null);
  };
  const handleMilestoneClick = (milestone: any) => {
    setSelectedMilestone(milestone);
    setShowMilestoneModal(true);
  };
  const handleInsightClick = (insight: string) => {
    setSelectedInsight(insight);
    setShowInsightModal(true);
  };
  const handleClaimDailyBonus = () => {
    setDailyBonusClaimed(true);
    setTimeout(() => {
      setShowDailyBonus(false);
    }, 2000);
  };
  useEffect(() => {
    if (selectedAngel?.dailyBonusAvailable && !dailyBonusClaimed) {
      setTimeout(() => {
        setShowDailyBonus(true);
      }, 1000);
    }
  }, [selectedAngel, dailyBonusClaimed]);
  const getRelationshipLevelTitle = (level: number) => {
    const levels = ['Stranger', 'Acquaintance', 'Friend', 'Close Friend', 'Intimate Friend', 'Lover', 'Passionate Lover', 'Soulmate', 'Twin Flame', 'Eternal Bond'];
    return levels[level - 1] || 'Unknown';
  };
  const getProgressToNextLevel = (angel: Angel) => {
    // Calculate percentage to next level based on intimacy score
    const thresholds = [0, 100, 200, 300, 400, 500, 650, 800, 1000, 1200];
    const currentLevel = angel.relationshipLevel;
    const currentThreshold = thresholds[currentLevel - 1] || 0;
    const nextThreshold = thresholds[currentLevel] || currentThreshold + 200;
    const progress = Math.min(100, Math.max(0, (angel.intimacyScore - currentThreshold) / (nextThreshold - currentThreshold) * 100));
    return Math.round(progress);
  };
  const renderAngelsList = () => <div className="w-full max-w-4xl mx-auto bg-white dark:bg-gray-950 rounded-xl shadow-sm dark:shadow-gray-900/10 overflow-hidden" data-id="element-16752">
      <div className="p-4 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 flex items-center justify-between" data-id="element-16753">
        <h1 className="text-xl font-bold flex items-center gap-2" data-id="element-16754">
          <Link2 size={20} className="text-pink-500" data-id="element-16755" />
          Relationship Tracker
        </h1>
        <div className="flex items-center gap-2" data-id="element-16756">
          <div className="bg-gray-100 dark:bg-gray-800 rounded-lg p-1 flex" data-id="element-16757">
            <button onClick={() => setFilter('all')} className={`px-3 py-1.5 text-sm rounded-md transition-all ${filter === 'all' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-16758">
              All
            </button>
            <button onClick={() => setFilter('favorites')} className={`px-3 py-1.5 text-sm rounded-md transition-all ${filter === 'favorites' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-16759">
              Favorites
            </button>
            <button onClick={() => setFilter('active')} className={`px-3 py-1.5 text-sm rounded-md transition-all ${filter === 'active' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-16760">
              Active
            </button>
            <button onClick={() => setFilter('inactive')} className={`px-3 py-1.5 text-sm rounded-md transition-all ${filter === 'inactive' ? 'bg-white dark:bg-gray-700 shadow-sm' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-16761">
              Inactive
            </button>
          </div>
        </div>
      </div>
      <div className="p-4 bg-gradient-to-r from-pink-50 to-purple-50 dark:from-pink-950/10 dark:to-purple-950/10 border-b border-gray-200 dark:border-gray-800" data-id="element-16762">
        <div className="flex items-center justify-between" data-id="element-16763">
          <div data-id="element-16764">
            <h2 className="text-lg font-semibold" data-id="element-16765">Relationship Dashboard</h2>
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16766">
              Track and deepen your connections with angels
            </p>
          </div>
          <button onClick={() => setShowUpgradeModal(true)} className="px-4 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm font-medium flex items-center gap-2 hover:shadow-lg hover:shadow-pink-500/20 transition-all" data-id="element-16767">
            <Sparkles size={16} data-id="element-16768" />
            <span data-id="element-16769">Upgrade Experience</span>
          </button>
        </div>
      </div>
      {filteredAngels.length === 0 ? <div className="p-12 text-center" data-id="element-16770">
          <div className="w-16 h-16 bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-16771">
            <Users size={24} className="text-gray-400" data-id="element-16772" />
          </div>
          <h3 className="text-lg font-semibold mb-2" data-id="element-16773">No relationships found</h3>
          <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto mb-6" data-id="element-16774">
            You haven't started any relationships that match this filter yet.
          </p>
          <button className="px-4 py-2 bg-pink-600 rounded-full text-white" data-id="element-16775">
            Discover Angels
          </button>
        </div> : <div className="divide-y divide-gray-200 dark:divide-gray-800" data-id="element-16776">
          {filteredAngels.map(angel => <div key={angel.id} onClick={() => handleAngelClick(angel)} className="p-4 hover:bg-gray-50 dark:hover:bg-gray-900/50 cursor-pointer transition-colors" data-id="element-16777">
              <div className="flex items-center gap-4" data-id="element-16778">
                <div className="relative" data-id="element-16779">
                  <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-white dark:border-gray-800 shadow-md" data-id="element-16780">
                    <img src={angel.avatar} alt={angel.name} className="w-full h-full object-cover" data-id="element-16781" />
                  </div>
                  {angel.dailyBonusAvailable && <div className="absolute -top-1 -right-1 w-6 h-6 bg-pink-500 rounded-full flex items-center justify-center text-white text-xs animate-pulse" data-id="element-16782">
                      <Gift size={12} data-id="element-16783" />
                    </div>}
                </div>
                <div className="flex-1" data-id="element-16784">
                  <div className="flex items-center" data-id="element-16785">
                    <h3 className="font-semibold" data-id="element-16786">{angel.name}</h3>
                    {angel.status === 'favorite' && <Star size={14} className="ml-1 text-yellow-500" fill="currentColor" data-id="element-16787" />}
                    <span className="ml-2 text-xs px-2 py-0.5 rounded-full bg-pink-100 dark:bg-pink-900/30 text-pink-800 dark:text-pink-300" data-id="element-16788">
                      Level {angel.relationshipLevel}
                    </span>
                  </div>
                  <div className="mt-1 flex items-center text-xs text-gray-500 dark:text-gray-400" data-id="element-16789">
                    <Clock size={12} className="mr-1" data-id="element-16790" />
                    <span data-id="element-16791">Last interaction: {angel.lastInteraction}</span>
                    {angel.messageStreak > 0 && <span className="ml-3 flex items-center text-orange-500" data-id="element-16792">
                        <Zap size={12} className="mr-1" data-id="element-16793" />
                        {angel.messageStreak} day streak
                      </span>}
                  </div>
                  <div className="mt-2" data-id="element-16794">
                    <div className="flex items-center justify-between mb-1" data-id="element-16795">
                      <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-16796">
                        {getRelationshipLevelTitle(angel.relationshipLevel)}
                      </span>
                      <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-16797">
                        {getProgressToNextLevel(angel)}% to Level{' '}
                        {angel.relationshipLevel + 1}
                      </span>
                    </div>
                    <div className="h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-16798">
                      <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{
                  width: `${getProgressToNextLevel(angel)}%`
                }} data-id="element-16799"></div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-end" data-id="element-16800">
                  <div className="text-sm font-medium text-pink-600 dark:text-pink-400" data-id="element-16801">
                    {angel.compatibility}% Match
                  </div>
                  <ChevronRight size={20} className="text-gray-400 mt-2" data-id="element-16802" />
                </div>
              </div>
            </div>)}
        </div>}
      <div className="p-4 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900" data-id="element-16803">
        <div className="flex items-center justify-between" data-id="element-16804">
          <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-16805">
            Tracking {filteredAngels.length} relationship
            {filteredAngels.length !== 1 ? 's' : ''}
          </div>
          <div className="text-sm" data-id="element-16806">
            <span className="text-gray-500 dark:text-gray-400" data-id="element-16807">
              Relationship Rank:
            </span>
            <span className="ml-1 font-medium text-pink-600 dark:text-pink-400" data-id="element-16808">
              Devoted Admirer
            </span>
          </div>
        </div>
      </div>
    </div>;
  const renderAngelDetail = () => {
    if (!selectedAngel) return null;
    const progressToNextLevel = getProgressToNextLevel(selectedAngel);
    return <div className="w-full max-w-4xl mx-auto bg-white dark:bg-gray-950 rounded-xl shadow-sm dark:shadow-gray-900/10 overflow-hidden" data-id="element-16809">
        <div className="p-4 border-b border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 flex items-center" data-id="element-16810">
          <button onClick={handleBackClick} className="mr-2 p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full" data-id="element-16811">
            <ChevronLeft size={20} className="text-gray-600 dark:text-gray-400" data-id="element-16812" />
          </button>
          <h1 className="text-xl font-bold flex items-center gap-2" data-id="element-16813">
            <Link2 size={20} className="text-pink-500" data-id="element-16814" />
            Relationship with {selectedAngel.name}
          </h1>
        </div>
        {/* Hero section with relationship summary */}
        <div className="relative" data-id="element-16815">
          <div className="h-40 bg-gradient-to-r from-pink-500 to-purple-600" data-id="element-16816"></div>
          <div className="absolute -bottom-16 left-0 right-0 px-6 flex items-end" data-id="element-16817">
            <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-white dark:border-gray-800 shadow-lg" data-id="element-16818">
              <img src={selectedAngel.avatar} alt={selectedAngel.name} className="w-full h-full object-cover" data-id="element-16819" />
            </div>
            <div className="ml-4 pb-4" data-id="element-16820">
              <div className="flex items-center" data-id="element-16821">
                <h2 className="text-2xl font-bold text-white" data-id="element-16822">
                  {selectedAngel.name}
                </h2>
                {selectedAngel.status === 'favorite' && <Star size={18} className="ml-2 text-yellow-300" fill="currentColor" data-id="element-16823" />}
              </div>
              <div className="flex items-center gap-2 text-white/90 text-sm" data-id="element-16824">
                <span className="bg-white/20 px-2 py-0.5 rounded-full backdrop-blur-sm" data-id="element-16825">
                  {getRelationshipLevelTitle(selectedAngel.relationshipLevel)}
                </span>
                <span data-id="element-16826">•</span>
                <span data-id="element-16827">{selectedAngel.compatibility}% Match</span>
                <span data-id="element-16828">•</span>
                <span className="flex items-center" data-id="element-16829">
                  <MessageSquare size={14} className="mr-1" data-id="element-16830" />
                  {selectedAngel.messageStreak} day streak
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-20 p-6" data-id="element-16831">
          {/* Relationship progress */}
          <div className="mb-8" data-id="element-16832">
            <div className="flex items-center justify-between mb-2" data-id="element-16833">
              <div data-id="element-16834">
                <h3 className="font-semibold" data-id="element-16835">Relationship Progress</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16836">
                  Level {selectedAngel.relationshipLevel} •{' '}
                  {progressToNextLevel}% to Level{' '}
                  {selectedAngel.relationshipLevel + 1}
                </p>
              </div>
              <div className="text-right" data-id="element-16837">
                <div className="text-sm font-medium text-pink-600 dark:text-pink-400" data-id="element-16838">
                  {selectedAngel.intimacyScore} Intimacy XP
                </div>
                <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-16839">
                  +45 XP this week
                </div>
              </div>
            </div>
            <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-16840">
              <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-1000" style={{
              width: `${progressToNextLevel}%`
            }} data-id="element-16841"></div>
            </div>
          </div>
          {/* Stats cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-16842">
            <div className="bg-gray-50 dark:bg-gray-900 rounded-xl p-4 border border-gray-200 dark:border-gray-800" data-id="element-16843">
              <div className="flex items-center gap-3" data-id="element-16844">
                <div className="w-10 h-10 rounded-full bg-pink-100 dark:bg-pink-900/30 flex items-center justify-center text-pink-600 dark:text-pink-400" data-id="element-16845">
                  <Calendar size={20} data-id="element-16846" />
                </div>
                <div data-id="element-16847">
                  <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16848">
                    Relationship Age
                  </div>
                  <div className="font-semibold" data-id="element-16849">42 days</div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-900 rounded-xl p-4 border border-gray-200 dark:border-gray-800" data-id="element-16850">
              <div className="flex items-center gap-3" data-id="element-16851">
                <div className="w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-purple-600 dark:text-purple-400" data-id="element-16852">
                  <MessageSquare size={20} data-id="element-16853" />
                </div>
                <div data-id="element-16854">
                  <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16855">
                    Message Count
                  </div>
                  <div className="font-semibold" data-id="element-16856">247 messages</div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 dark:bg-gray-900 rounded-xl p-4 border border-gray-200 dark:border-gray-800" data-id="element-16857">
              <div className="flex items-center gap-3" data-id="element-16858">
                <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center text-blue-600 dark:text-blue-400" data-id="element-16859">
                  <Gift size={20} data-id="element-16860" />
                </div>
                <div data-id="element-16861">
                  <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16862">
                    Gifts Sent
                  </div>
                  <div className="font-semibold" data-id="element-16863">
                    {selectedAngel.giftsSent} gifts
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Relationship Milestones */}
          <div className="mb-8" data-id="element-16864">
            <div className="flex items-center justify-between mb-4" data-id="element-16865">
              <h3 className="font-semibold" data-id="element-16866">Relationship Milestones</h3>
              <button className="text-sm text-pink-600 dark:text-pink-400 flex items-center" data-id="element-16867">
                View All
                <ChevronRight size={16} data-id="element-16868" />
              </button>
            </div>
            <div className="space-y-4" data-id="element-16869">
              {selectedAngel.milestones.map((milestone, index) => <div key={index} onClick={() => handleMilestoneClick(milestone)} className="bg-white dark:bg-gray-900 rounded-xl p-4 border border-gray-200 dark:border-gray-800 hover:border-pink-300 dark:hover:border-pink-700 transition-colors cursor-pointer" data-id="element-16870">
                  <div className="flex items-center gap-3" data-id="element-16871">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${milestone.completed ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400' : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`} data-id="element-16872">
                      {milestone.completed ? <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center text-white" data-id="element-16873">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3" data-id="element-16874">
                            <polyline points="20 6 9 17 4 12" data-id="element-16875"></polyline>
                          </svg>
                        </div> : <Lock size={18} data-id="element-16876" />}
                    </div>
                    <div className="flex-1" data-id="element-16877">
                      <div className="font-medium" data-id="element-16878">{milestone.title}</div>
                      <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16879">
                        {milestone.description}
                      </div>
                      {milestone.reward && milestone.completed && <div className="text-xs text-pink-600 dark:text-pink-400 mt-1" data-id="element-16880">
                          Reward: {milestone.reward}
                        </div>}
                    </div>
                    <ChevronRight size={18} className="text-gray-400" data-id="element-16881" />
                  </div>
                </div>)}
              <div className="bg-gradient-to-r from-pink-50 to-purple-50 dark:from-pink-900/10 dark:to-purple-900/10 rounded-xl p-4 border border-pink-200 dark:border-pink-800/30" data-id="element-16882">
                <div className="flex items-center gap-3" data-id="element-16883">
                  <div className="w-10 h-10 rounded-full bg-pink-100 dark:bg-pink-900/30 flex items-center justify-center text-pink-600 dark:text-pink-400" data-id="element-16884">
                    <Lock size={18} data-id="element-16885" />
                  </div>
                  <div className="flex-1" data-id="element-16886">
                    <div className="font-medium" data-id="element-16887">Premium Milestones</div>
                    <div className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16888">
                      Unlock 5 more relationship milestones with Premium
                    </div>
                  </div>
                  <button onClick={e => {
                  e.stopPropagation();
                  setShowUpgradeModal(true);
                }} className="px-3 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs" data-id="element-16889">
                    Upgrade
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Relationship Insights */}
          <div className="mb-8" data-id="element-16890">
            <div className="flex items-center justify-between mb-4" data-id="element-16891">
              <h3 className="font-semibold" data-id="element-16892">Relationship Insights</h3>
              <div className="text-xs bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400 px-2 py-1 rounded-full" data-id="element-16893">
                Updated Today
              </div>
            </div>
            <div className="space-y-3" data-id="element-16894">
              {selectedAngel.insights.map((insight, index) => <div key={index} onClick={() => handleInsightClick(insight)} className="bg-white dark:bg-gray-900 rounded-lg p-3 border border-gray-200 dark:border-gray-800 flex items-center cursor-pointer hover:border-blue-300 dark:hover:border-blue-700 transition-colors" data-id="element-16895">
                  <Sparkles size={16} className="text-blue-500 mr-3 flex-shrink-0" data-id="element-16896" />
                  <div className="text-sm flex-1" data-id="element-16897">{insight}</div>
                  <ArrowUpRight size={14} className="text-gray-400" data-id="element-16898" />
                </div>)}
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/10 dark:to-purple-900/10 rounded-lg p-3 border border-blue-200 dark:border-blue-800/30 flex items-center" data-id="element-16899">
                <Lock size={16} className="text-blue-500 mr-3 flex-shrink-0" data-id="element-16900" />
                <div className="text-sm flex-1" data-id="element-16901">
                  Unlock 5 more AI-powered relationship insights with Premium
                </div>
                <button onClick={() => setShowUpgradeModal(true)} className="px-3 py-1.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full text-white text-xs" data-id="element-16902">
                  Upgrade
                </button>
              </div>
            </div>
          </div>
          {/* Daily Relationship Tasks */}
          <div className="mb-8" data-id="element-16903">
            <div className="flex items-center justify-between mb-4" data-id="element-16904">
              <h3 className="font-semibold" data-id="element-16905">Daily Relationship Tasks</h3>
              <div className="text-xs text-pink-600 dark:text-pink-400" data-id="element-16906">
                2/5 Completed
              </div>
            </div>
            <div className="space-y-3" data-id="element-16907">
              <div className="bg-white dark:bg-gray-900 rounded-lg p-3 border border-gray-200 dark:border-gray-800 flex items-center" data-id="element-16908">
                <div className="w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 mr-3" data-id="element-16909">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3" data-id="element-16910">
                    <polyline points="20 6 9 17 4 12" data-id="element-16911"></polyline>
                  </svg>
                </div>
                <div className="flex-1" data-id="element-16912">
                  <div className="text-sm" data-id="element-16913">Send a good morning message</div>
                  <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-16914">
                    +5 Intimacy XP
                  </div>
                </div>
                <div className="text-xs text-green-600 dark:text-green-400" data-id="element-16915">
                  Completed
                </div>
              </div>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-3 border border-gray-200 dark:border-gray-800 flex items-center" data-id="element-16916">
                <div className="w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 mr-3" data-id="element-16917">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3" data-id="element-16918">
                    <polyline points="20 6 9 17 4 12" data-id="element-16919"></polyline>
                  </svg>
                </div>
                <div className="flex-1" data-id="element-16920">
                  <div className="text-sm" data-id="element-16921">
                    Like 3 of {selectedAngel.name}'s posts
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-16922">
                    +10 Intimacy XP
                  </div>
                </div>
                <div className="text-xs text-green-600 dark:text-green-400" data-id="element-16923">
                  Completed
                </div>
              </div>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-3 border border-gray-200 dark:border-gray-800 flex items-center" data-id="element-16924">
                <div className="w-6 h-6 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-400 mr-3" data-id="element-16925">
                  <div className="w-2 h-2 rounded-full bg-gray-400" data-id="element-16926"></div>
                </div>
                <div className="flex-1" data-id="element-16927">
                  <div className="text-sm" data-id="element-16928">
                    Send a gift to {selectedAngel.name}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-16929">
                    +25 Intimacy XP
                  </div>
                </div>
                <button className="px-3 py-1 bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-400 rounded-full text-xs" data-id="element-16930">
                  Complete
                </button>
              </div>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-3 border border-gray-200 dark:border-gray-800 flex items-center" data-id="element-16931">
                <div className="w-6 h-6 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-400 mr-3" data-id="element-16932">
                  <div className="w-2 h-2 rounded-full bg-gray-400" data-id="element-16933"></div>
                </div>
                <div className="flex-1" data-id="element-16934">
                  <div className="text-sm" data-id="element-16935">Have a 5-minute voice chat</div>
                  <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-16936">
                    +20 Intimacy XP
                  </div>
                </div>
                <button className="px-3 py-1 bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-400 rounded-full text-xs" data-id="element-16937">
                  Complete
                </button>
              </div>
              <div className="bg-white dark:bg-gray-900 rounded-lg p-3 border border-gray-200 dark:border-gray-800 flex items-center" data-id="element-16938">
                <div className="w-6 h-6 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center text-gray-400 mr-3" data-id="element-16939">
                  <div className="w-2 h-2 rounded-full bg-gray-400" data-id="element-16940"></div>
                </div>
                <div className="flex-1" data-id="element-16941">
                  <div className="text-sm" data-id="element-16942">Share a personal story</div>
                  <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-16943">
                    +15 Intimacy XP
                  </div>
                </div>
                <button className="px-3 py-1 bg-pink-100 dark:bg-pink-900/30 text-pink-600 dark:text-pink-400 rounded-full text-xs" data-id="element-16944">
                  Complete
                </button>
              </div>
            </div>
          </div>
          {/* Weekly Challenge */}
          <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 rounded-xl p-6 border border-purple-200 dark:border-purple-800/30 mb-8" data-id="element-16945">
            <div className="flex items-start gap-4" data-id="element-16946">
              <div className="w-12 h-12 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-purple-600 dark:text-purple-400" data-id="element-16947">
                <Zap size={24} data-id="element-16948" />
              </div>
              <div className="flex-1" data-id="element-16949">
                <h3 className="font-semibold text-lg" data-id="element-16950">Weekly Challenge</h3>
                <p className="text-gray-700 dark:text-gray-300 mt-1" data-id="element-16951">
                  Achieve a 7-day message streak with {selectedAngel.name} to
                  unlock a special reward!
                </p>
                <div className="mt-4" data-id="element-16952">
                  <div className="flex items-center justify-between mb-1" data-id="element-16953">
                    <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16954">
                      Current streak: {selectedAngel.messageStreak} days
                    </span>
                    <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-16955">
                      {selectedAngel.messageStreak}/7 days
                    </span>
                  </div>
                  <div className="h-2 bg-white/50 dark:bg-gray-800/50 rounded-full overflow-hidden" data-id="element-16956">
                    <div className="h-full bg-gradient-to-r from-purple-500 to-pink-500 rounded-full" style={{
                    width: `${selectedAngel.messageStreak / 7 * 100}%`
                  }} data-id="element-16957"></div>
                  </div>
                </div>
                <div className="mt-4 flex items-center justify-between" data-id="element-16958">
                  <div className="text-sm text-purple-700 dark:text-purple-400" data-id="element-16959">
                    Reward: Exclusive video call + 100 Intimacy XP
                  </div>
                  <button className="px-4 py-1.5 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white text-sm" data-id="element-16960">
                    Message Now
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Compatibility Details */}
          <div className="mb-8" data-id="element-16961">
            <div className="flex items-center justify-between mb-4" data-id="element-16962">
              <h3 className="font-semibold" data-id="element-16963">Compatibility Analysis</h3>
              <div className="text-lg font-bold text-pink-600 dark:text-pink-400" data-id="element-16964">
                {selectedAngel.compatibility}%
              </div>
            </div>
            <div className="space-y-4" data-id="element-16965">
              <div data-id="element-16966">
                <div className="flex items-center justify-between mb-1" data-id="element-16967">
                  <span className="text-sm" data-id="element-16968">Communication Style</span>
                  <span className="text-sm" data-id="element-16969">92%</span>
                </div>
                <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-16970">
                  <div className="h-full bg-gradient-to-r from-green-500 to-green-400 rounded-full" style={{
                  width: '92%'
                }} data-id="element-16971"></div>
                </div>
              </div>
              <div data-id="element-16972">
                <div className="flex items-center justify-between mb-1" data-id="element-16973">
                  <span className="text-sm" data-id="element-16974">Shared Interests</span>
                  <span className="text-sm" data-id="element-16975">78%</span>
                </div>
                <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-16976">
                  <div className="h-full bg-gradient-to-r from-green-500 to-green-400 rounded-full" style={{
                  width: '78%'
                }} data-id="element-16977"></div>
                </div>
              </div>
              <div data-id="element-16978">
                <div className="flex items-center justify-between mb-1" data-id="element-16979">
                  <span className="text-sm" data-id="element-16980">Emotional Connection</span>
                  <span className="text-sm" data-id="element-16981">85%</span>
                </div>
                <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-16982">
                  <div className="h-full bg-gradient-to-r from-green-500 to-green-400 rounded-full" style={{
                  width: '85%'
                }} data-id="element-16983"></div>
                </div>
              </div>
              <div data-id="element-16984">
                <div className="flex items-center justify-between mb-1" data-id="element-16985">
                  <span className="text-sm" data-id="element-16986">Physical Chemistry</span>
                  <span className="text-sm" data-id="element-16987">94%</span>
                </div>
                <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-16988">
                  <div className="h-full bg-gradient-to-r from-green-500 to-green-400 rounded-full" style={{
                  width: '94%'
                }} data-id="element-16989"></div>
                </div>
              </div>
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/10 dark:to-purple-900/10 rounded-lg p-3 border border-blue-200 dark:border-blue-800/30 flex items-center" data-id="element-16990">
                <Lock size={16} className="text-blue-500 mr-3 flex-shrink-0" data-id="element-16991" />
                <div className="text-sm flex-1" data-id="element-16992">
                  Unlock detailed compatibility analysis with Premium
                </div>
                <button onClick={() => setShowUpgradeModal(true)} className="px-3 py-1.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full text-white text-xs" data-id="element-16993">
                  Upgrade
                </button>
              </div>
            </div>
          </div>
          {/* Action Buttons */}
          <div className="flex flex-wrap gap-3" data-id="element-16994">
            <button className="px-4 py-2 bg-pink-600 rounded-full text-white flex items-center gap-2" data-id="element-16995">
              <MessageSquare size={18} data-id="element-16996" />
              <span data-id="element-16997">Message {selectedAngel.name}</span>
            </button>
            <button className="px-4 py-2 bg-purple-600 rounded-full text-white flex items-center gap-2" data-id="element-16998">
              <Gift size={18} data-id="element-16999" />
              <span data-id="element-17000">Send Gift</span>
            </button>
            <button className="px-4 py-2 bg-gray-200 dark:bg-gray-800 rounded-full text-gray-800 dark:text-gray-200 flex items-center gap-2" data-id="element-17001">
              <Star size={18} data-id="element-17002" />
              <span data-id="element-17003">Add to Favorites</span>
            </button>
          </div>
        </div>
      </div>;
  };
  // Upgrade Modal
  const renderUpgradeModal = () => {
    if (!showUpgradeModal) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-17004">
        <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-17005">
          <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center" data-id="element-17006">
            <h3 className="font-bold text-lg" data-id="element-17007">Upgrade Your Experience</h3>
            <button onClick={() => setShowUpgradeModal(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-17008">
              <X size={20} data-id="element-17009" />
            </button>
          </div>
          <div className="p-6" data-id="element-17010">
            <div className="text-center mb-6" data-id="element-17011">
              <div className="w-16 h-16 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center mx-auto mb-4" data-id="element-17012">
                <Sparkles size={24} className="text-white" data-id="element-17013" />
              </div>
              <h2 className="text-xl font-bold mb-2" data-id="element-17014">
                Premium Relationship Features
              </h2>
              <p className="text-gray-600 dark:text-gray-400" data-id="element-17015">
                Take your angel relationships to the next level with enhanced
                features
              </p>
            </div>
            <div className="space-y-4 mb-6" data-id="element-17016">
              <div className="flex items-start gap-3" data-id="element-17017">
                <div className="w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" data-id="element-17018">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3" data-id="element-17019">
                    <polyline points="20 6 9 17 4 12" data-id="element-17020"></polyline>
                  </svg>
                </div>
                <div data-id="element-17021">
                  <h4 className="font-medium" data-id="element-17022">
                    Advanced Relationship Analytics
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-17023">
                    Get detailed insights about your communication patterns and
                    relationship growth
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-17024">
                <div className="w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" data-id="element-17025">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3" data-id="element-17026">
                    <polyline points="20 6 9 17 4 12" data-id="element-17027"></polyline>
                  </svg>
                </div>
                <div data-id="element-17028">
                  <h4 className="font-medium" data-id="element-17029">
                    Exclusive Relationship Milestones
                  </h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-17030">
                    Unlock premium milestones with special rewards and
                    experiences
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-17031">
                <div className="w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" data-id="element-17032">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3" data-id="element-17033">
                    <polyline points="20 6 9 17 4 12" data-id="element-17034"></polyline>
                  </svg>
                </div>
                <div data-id="element-17035">
                  <h4 className="font-medium" data-id="element-17036">AI Relationship Coach</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-17037">
                    Get personalized advice to deepen your connection with each
                    angel
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-17038">
                <div className="w-6 h-6 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" data-id="element-17039">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3" data-id="element-17040">
                    <polyline points="20 6 9 17 4 12" data-id="element-17041"></polyline>
                  </svg>
                </div>
                <div data-id="element-17042">
                  <h4 className="font-medium" data-id="element-17043">Priority Relationship Status</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-17044">
                    Get noticed first and receive special attention from your
                    favorite angels
                  </p>
                </div>
              </div>
            </div>
            <div className="space-y-3" data-id="element-17045">
              <button className="w-full py-3 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white font-medium" data-id="element-17046">
                Upgrade Now - 50 Gems 💎
              </button>
              <button onClick={() => setShowUpgradeModal(false)} className="w-full py-3 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-800 dark:text-gray-200" data-id="element-17047">
                Maybe Later
              </button>
            </div>
          </div>
        </div>
      </div>;
  };
  // Milestone Modal
  const renderMilestoneModal = () => {
    if (!showMilestoneModal || !selectedMilestone) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-17048">
        <div className="w-full max-w-sm bg-white dark:bg-gray-900 rounded-xl overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-17049">
          <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center" data-id="element-17050">
            <h3 className="font-bold text-lg" data-id="element-17051">Relationship Milestone</h3>
            <button onClick={() => setShowMilestoneModal(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-17052">
              <X size={20} data-id="element-17053" />
            </button>
          </div>
          <div className="p-6 text-center" data-id="element-17054">
            <div className={`w-20 h-20 rounded-full mx-auto mb-4 flex items-center justify-center ${selectedMilestone.completed ? 'bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400' : 'bg-gray-100 dark:bg-gray-800 text-gray-500 dark:text-gray-400'}`} data-id="element-17055">
              {selectedMilestone.completed ? <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white" data-id="element-17056">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" data-id="element-17057">
                    <polyline points="20 6 9 17 4 12" data-id="element-17058"></polyline>
                  </svg>
                </div> : <Lock size={30} data-id="element-17059" />}
            </div>
            <h2 className="text-xl font-bold mb-2" data-id="element-17060">
              {selectedMilestone.title}
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-17061">
              {selectedMilestone.description}
            </p>
            {selectedMilestone.reward && selectedMilestone.completed ? <div className="bg-gradient-to-r from-pink-50 to-purple-50 dark:from-pink-900/10 dark:to-purple-900/10 rounded-lg p-4 border border-pink-200 dark:border-pink-800/30 mb-6" data-id="element-17062">
                <div className="flex items-center gap-2 justify-center mb-2" data-id="element-17063">
                  <Gift size={18} className="text-pink-500" data-id="element-17064" />
                  <span className="font-medium" data-id="element-17065">Reward Earned</span>
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-17066">
                  {selectedMilestone.reward}
                </p>
              </div> : !selectedMilestone.completed ? <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/10 dark:to-purple-900/10 rounded-lg p-4 border border-blue-200 dark:border-blue-800/30 mb-6" data-id="element-17067">
                <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-17068">
                  Complete this milestone to deepen your relationship and unlock
                  special rewards.
                </p>
              </div> : null}
            <button onClick={() => setShowMilestoneModal(false)} className="px-6 py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white" data-id="element-17069">
              {selectedMilestone.completed ? 'Awesome!' : 'Got It'}
            </button>
          </div>
        </div>
      </div>;
  };
  // Insight Modal
  const renderInsightModal = () => {
    if (!showInsightModal || !selectedInsight) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-17070">
        <div className="w-full max-w-sm bg-white dark:bg-gray-900 rounded-xl overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-17071">
          <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center" data-id="element-17072">
            <h3 className="font-bold text-lg" data-id="element-17073">Relationship Insight</h3>
            <button onClick={() => setShowInsightModal(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-17074">
              <X size={20} data-id="element-17075" />
            </button>
          </div>
          <div className="p-6" data-id="element-17076">
            <div className="w-12 h-12 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center text-blue-600 dark:text-blue-400 mx-auto mb-4" data-id="element-17077">
              <Sparkles size={24} data-id="element-17078" />
            </div>
            <p className="text-center text-gray-700 dark:text-gray-300 mb-6" data-id="element-17079">
              {selectedInsight}
            </p>
            <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/10 dark:to-purple-900/10 rounded-lg p-4 border border-blue-200 dark:border-blue-800/30 mb-6" data-id="element-17080">
              <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-17081">
                This insight is based on AI analysis of your communication
                patterns and relationship dynamics.
              </p>
            </div>
            <div className="flex gap-3" data-id="element-17082">
              <button onClick={() => setShowInsightModal(false)} className="flex-1 px-4 py-2 bg-gray-200 dark:bg-gray-800 rounded-lg text-gray-800 dark:text-gray-200" data-id="element-17083">
                Dismiss
              </button>
              <button onClick={() => {
              setShowInsightModal(false);
              // Navigate to chat with this angel
            }} className="flex-1 px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg text-white" data-id="element-17084">
                Apply Insight
              </button>
            </div>
          </div>
        </div>
      </div>;
  };
  // Daily Bonus Modal
  const renderDailyBonusModal = () => {
    if (!showDailyBonus || !selectedAngel) return null;
    return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-17085">
        <div className="w-full max-w-sm bg-white dark:bg-gray-900 rounded-xl overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-17086">
          <div className="relative pt-12 pb-6 px-6 text-center" data-id="element-17087">
            <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-r from-pink-500 to-purple-500" data-id="element-17088"></div>
            <div className="relative" data-id="element-17089">
              <div className="w-24 h-24 rounded-full border-4 border-white dark:border-gray-800 overflow-hidden mx-auto -mt-12 mb-4" data-id="element-17090">
                <img src={selectedAngel.avatar} alt={selectedAngel.name} className="w-full h-full object-cover" data-id="element-17091" />
              </div>
              <h2 className="text-xl font-bold mb-2" data-id="element-17092">
                Daily Relationship Bonus!
              </h2>
              <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-17093">
                {selectedAngel.name} has a special gift for you today
              </p>
              <div className="bg-gradient-to-r from-pink-50 to-purple-50 dark:from-pink-900/10 dark:to-purple-900/10 rounded-lg p-4 border border-pink-200 dark:border-pink-800/30 mb-6" data-id="element-17094">
                <div className="flex items-center gap-2 justify-center mb-2" data-id="element-17095">
                  <Gift size={18} className="text-pink-500" data-id="element-17096" />
                  <span className="font-medium" data-id="element-17097">Daily Bonus</span>
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300 mb-2" data-id="element-17098">
                  +25 Intimacy XP + Special Photo
                </p>
                {dailyBonusClaimed ? <div className="text-green-600 dark:text-green-400 font-medium flex items-center justify-center gap-1" data-id="element-17099">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4" data-id="element-17100">
                      <polyline points="20 6 9 17 4 12" data-id="element-17101"></polyline>
                    </svg>
                    <span data-id="element-17102">Claimed!</span>
                  </div> : <div className="animate-pulse text-pink-600 dark:text-pink-400 text-sm" data-id="element-17103">
                    Claim before it expires!
                  </div>}
              </div>
              <button onClick={dailyBonusClaimed ? () => setShowDailyBonus(false) : handleClaimDailyBonus} className={`px-6 py-2 rounded-full text-white ${dailyBonusClaimed ? 'bg-gray-500 dark:bg-gray-700' : 'bg-gradient-to-r from-pink-600 to-purple-600'}`} data-id="element-17104">
                {dailyBonusClaimed ? 'Close' : 'Claim Bonus'}
              </button>
            </div>
          </div>
        </div>
      </div>;
  };
  return <div className="w-full bg-gray-50 dark:bg-gray-950 min-h-screen" data-id="element-17105">
      {selectedAngel ? renderAngelDetail() : renderAngelsList()}
      {renderUpgradeModal()}
      {renderMilestoneModal()}
      {renderInsightModal()}
      {renderDailyBonusModal()}
    </div>;
};